module.exports = __webpack_public_path__ + "img/couples-073.b301902c.jpg";